<template>
  <div>
    <van-nav-bar :title="pageTitle" :left-arrow="$route.meta.index > 2 " @click-left="onClickLeft" fixed v-if="$route.path !== '/chargingPage'"/>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {}
  },
  computed: {
    pageTitle() {
      return this.$route.query.title ? this.$route.query.title : this.$route.meta.title
    }
  },
  watch: {},
  methods: {
    onClickLeft () {
      if (this.$route.query.backUrl){
        this.$router.replace({name: this.$route.query.backUrl, query: this.$route.query.backQuery ? JSON.parse(this.$route.query.backQuery) : {}})
        return false
      }
      return false
      if(this.$route.query.back) {
        this.$router.back(-1)
        return false
      }
      if (this.$route.path === '/userIn/orderDetails') {
        this.$router.push('/userIn/userOrder')
      } else if (this.$route.path === '/userIn/userOrder') {
        this.$router.push('/user')
      } else {
        this.$router.back(-1)
      }
    }
  },
  mounted () {
  },
  created () {
  },
  components: {}
}
</script>

<style lang='less'>
  /*.van-nav-bar--fixed{*/
    /*-moz-box-shadow:1px 1px 3px #BDBDBD;*/
    /*-webkit-box-shadow:1px 1px 3px #BDBDBD;*/
    /*box-shadow:1px 1px 3px #BDBDBD;*/
  /*}*/

  .van-nav-bar{
    z-index: 100!important;
  }
  .van-nav-bar .van-icon{
    color: #00d8a0 !important;
  }
</style>
